// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"8be9ae61","215":"346af95f","872":"1a706abc"}[chunkId] + ".js";
};